/*global document, location */

const initHTML = () => {
    // Remove loading error text node
    const loadingErrorText = document.getElementById('loading-error');
    if (loadingErrorText) {
        loadingErrorText.parentNode.removeChild(loadingErrorText);
    }
};

// ---

export { initHTML };
